import React from "react";

import { createStackNavigator } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";

import Achats from "./Achats";


const Stack = createStackNavigator();

const AchatsStack = () => {

    const { t, i18n } = useTranslation();

    return (
        <Stack.Navigator>
            <Stack.Screen
                name="achats"
                component={Achats}
                options={{
                    title: t("HEADER_ACHATS"),
                    headerStyle: {
                        backgroundColor: "#D71D9A",
                    },
                    headerTintColor: "#fff",
                    headerTitleStyle: {
                        fontWeight: "bold",
                    },
                }}
            />
        </Stack.Navigator>
    );
}

export default AchatsStack;